<script lang="ts">
  import { getWrapperStyles } from '../helpers/sections-helper';
  import HeroBlurb from './HeroBlurb.svelte';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  $: properties = {
    ...properties,
    backgroundColor: properties.backgroundOverlayColor,
  };
  $: ({ heading, backgroundHeroImage: backgroundImage } = properties);

  export const component = [
    {
      label: 'Heading',
      inputType: 'Text',
      value: properties.heading,
    },
    {
      label: 'Description',
      inputType: 'TextArea',
      value: properties.text,
    },
    {
      label: 'Button 1',
      inpuType: 'Button',
      value: {},
    },
    {
      label: 'Button 1',
      inpuType: 'Button',
      value: {},
    },
  ];
</script>

<section class="hero hero-1" id={properties?.anchor}>
  <div class="wrapper" style={getWrapperStyles()}>
    <HeroBlurb {properties} {settings} light wide centered />
  </div>
  <div class="overlay" />
  <div class="image">
    <img src={backgroundImage} alt={heading} />
  </div>
</section>

<style>
  .hero {
    position: relative;
    height: clamp(600px, 70vh, 70vh);
    overflow: hidden;
    background-color: #000;
    margin-bottom: 0;
  }
  :global(.hero-1 p ul) {
    display: inline-block;
    text-align: left;
    max-width: 300px;
  }
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0px;
    z-index: 1;
    background-color: #000;
    opacity: 0.5;
  }
  .wrapper {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    z-index: 2;
    padding: 0 15px;
  }
  .image {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0px;
    z-index: 0;
  }
  .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: var(--background-position, center);
  }
  @media screen and (max-width: 865px) {
    .hero {
      height: auto;
    }
  }
  @media screen and (max-width: 767px) {
    .wrapper {
      padding: 0 15px !important;
    }
  }
  @media screen and (max-width: 600px) {
    .image {
      margin-bottom: -40px;
    }
  }
</style>
